import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Task } from '../Task'

@InputType()
export class GetSortedTasksArgs extends ActionArgs {
  @Field(() => ID)
  taskIds: string[]
}

export interface IGetSortedTasks extends IAction<Task[], GetSortedTasksArgs> {}
